<template>
  <v-card class="d-flex flex-column asessment-card">
    <header-assessment
      class="mt-3"
      :data="headerData"
      pl="2vw"
      pr="2vw"
      title="Asesmen Poli Umum"
    />
    <v-divider class="mt-3"></v-divider>
    <div class="content-wrapper">
      <v-row v-if="!isLoading" no-gutters class="fill-height">
        <v-col class="form-container flex-grow-1" style="flex: 1">
          <InputAssessment
            ref="assessment"
            v-if="!emrData"
            @close-form="$emit('close-form')"
            :patient-data="patient"
            :is-emr="isEmr"
            :is-ihs="isIhs"
          />

          <InputAssessment
            ref="assessment"
            v-else
            @close-form="$emit('close-form')"
            :patient-data="patient"
            :is-emr="isEmr"
            :emr-data="emrData"
            :is-ihs="isIhs"
          />
        </v-col>
        <v-col class="sidebar-container" style="flex: 0.4">
          <history-sidebar
            :header-data="headerData"
            @navigate-to="navigateTo"
          />
          <!-- v-if="!isEmr && !isIhs" -->
        </v-col>
      </v-row>
    </div>
    <!-- </v-container> -->
  </v-card>
</template>

<script>
// components
import HistorySidebar from '../AssessmentComponents/HistorySidebarV2.vue';
import InputAssessment from './InputAssestment';
import HeaderAssessment from '../AssessmentComponents/HeaderAssessment.vue';
import formatMixin from '@/mixin/formatMixin';

// utils
const moment = require('moment');
// import { formatAddress } from '@/helper';

// api
import { getSocialDataByRmNumber } from '@/fetchApi/patient';

export default {
  name: 'GeneralPolyAssestment',
  mixins: [formatMixin],
  components: {
    InputAssessment,
    HistorySidebar,
    HeaderAssessment,
  },
  data() {
    return {
      headerData: null,
      patient: null,
      isLoading: true,
    };
  },
  props: {
    patientData: {
      type: Object,
      default: null,
    },
    idRegistration: {
      type: String,
      default: null,
    },
    rmNumber: {
      type: String,
      default: null,
    },
    isIhs: {
      type: Boolean,
      default: null,
    },
    isEmr: Boolean,
    emrData: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.getSocialData();
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    navigateTo(ref) {
      const el = this.$refs.assessment.$refs[ref];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async getSocialData() {
      try {
        this.isLoading = true;
        const response = await getSocialDataByRmNumber(
          this.patientData?.rmNumber || this.rmNumber,
        );
        this.assignHeaderData(response.data.data);
        this.assignPatientDataForProps(response.data.data);
      } catch {
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    assignHeaderData(data) {
      this.headerData = [
        {
          label: 'No RM',
          text: this.patientData?.rmNumber || this.rmNumber,
        },
        {
          label: 'Nama',
          text: `${data.display_name} (${data.gender ? 'L' : 'P'})`,
        },
        {
          label: 'Tanggal Lahir',
          text: `${moment(data.birth.date, 'YYYY-MM-DD')
            .locale('id')
            .format('DD MMMM YYYY')} (${this.ageDuration(
            moment(data.birth.date, 'YYYY-MM-DD'),
          )})`,
        },
        {
          label: 'Hambatan dalam Berkomunikasi',
          text: data.commmunication_obstacles || 'Tidak Ada',
        },
      ];
    },
    assignPatientDataForProps(data) {
      this.patient = {
        rmNumber: this.patientData?.rmNumber || this.rmNumber,
        meta: {
          name: data.name,
          birthDate: moment(data.birth.date, 'YYYY-MM-DD').format(
            'DD MMMM YYYY',
          ),
          bpjs: {
            number: data.assurance.number,
          },
          // name: data.name,
          // name: data.name,
          address: this.formatAddress(data.address),
          // poly: this.patientData?.meta?.poly,
          age: data.age,
          gender: data.gender,
          guarantorType: data.assurance.type,
          guarantorNumber: data.assurance.number,
          // poly: this.patientData.meta.poly,
          rmNumber: this.patientData?.rmNumber || this.rmNumber,
          // address: formatAddress(data.address),
          // address: data.address,
          poly: 'Poli Umum',
        },
        // rmNumber: this.patientData.rmNumber,
        id_registration:
          this.patientData?.id_registration || this.idRegistration,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.asessment-card {
  height: 90vh;
  max-height: 700px;
  width: 1200px;
  max-width: 95vw;
}

.content-wrapper {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}

.form-container {
  height: 100%;
}

.sidebar-container {
  height: 100%;
}
</style>
